import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const StoreContext = /*#__PURE__*/createContext(null);

// Provider to provide card data to card/section children.
function CardDataProvider({
  children,
  cardData
}) {
  const value = useMemo(() => ({
    cardData
  }), [cardData]);
  return /*#__PURE__*/_jsx(StoreContext.Provider, {
    value: value,
    children: children
  });
}

// Sections can easily access card data using this hook.
// This will prevent prop drilling.
export const useCardDataStore = () => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useCardDataStore must be inside CardDataProvider');
  }
  return store;
};
export default CardDataProvider;